import ALICANTE from 'url:../assets/posters/dec-2025/Alicante.png'
import BARCELONA from 'url:../assets/posters/dec-2025/Barcelona.png'
import BERLIN from 'url:../assets/posters/dec-2025/Berlin.png'
import BIRMINGHAM from 'url:../assets/posters/dec-2025/Birmingham.png'
import BONN from 'url:../assets/posters/dec-2025/Bonn.png'
import BONN_UkRAINIAN from 'url:../assets/posters/dec-2025/Bonn Ukrainian.png'
import BREMEN from 'url:../assets/posters/dec-2025/Bremen.png'
import CHICAGO from 'url:../assets/posters/dec-2025/Chicago.png'
import DALLAS from 'url:../assets/posters/dec-2025/Dallas.png'
import DEN_HAAG from 'url:../assets/posters/dec-2025/Den Haag.png'
import DENVER from 'url:../assets/posters/dec-2025/Denver.png'
import EDINBURGH from 'url:../assets/posters/dec-2025/Edinburgh.png'
import EDINBURGH_2 from 'url:../assets/posters/dec-2025/Edinburgh2.png'
import HAMBURG from 'url:../assets/posters/dec-2025/Hamburg.png'
import IZUMO from 'url:../assets/posters/dec-2025/Izumo.png'
import IZUMO_2 from 'url:../assets/posters/dec-2025/Izumo2.png'
import LEIPZIG from 'url:../assets/posters/dec-2025/Leipzig.png'
import LONDON from 'url:../assets/posters/dec-2025/London.png'
import LOS_ANGELES from 'url:../assets/posters/dec-2025/LosAngeles.png'
import MALAGA from 'url:../assets/posters/dec-2025/Malaga.png'
import MANCHESTER from 'url:../assets/posters/dec-2025/Manchester.png'
import MILAN from 'url:../assets/posters/dec-2025/Milan.png'
import MUNICH from 'url:../assets/posters/dec-2025/Munich.png'
import NEW_YORK from 'url:../assets/posters/dec-2025/New York.png'
import NEW_YORK_2 from 'url:../assets/posters/dec-2025/New York.png'
import OTTAWA from 'url:../assets/posters/dec-2025/Ottawa.png'
import PARIS from 'url:../assets/posters/dec-2025/Paris.png'
import PARIS_1 from 'url:../assets/posters/dec-2025/Paris1.png'
import SEATTLE from 'url:../assets/posters/dec-2025/Seattle.png'
import TEXAS from 'url:../assets/posters/dec-2025/Texas.png'
import TENERIFE from 'url:../assets/posters/dec-2025/Tenerife.png'
import VIENNA from 'url:../assets/posters/dec-2025/Vienna.png'
import MOTHER from 'url:../assets/posters/dec-2025/StopHumanSafari.png'

export const images = [
  { src: HAMBURG, city: 'hamburg' },
  { src: SEATTLE, city: 'seattle' },
  { src: MUNICH, city: 'munich' },
  { src: IZUMO_2, city: 'izumo' },
  { src: EDINBURGH, city: 'edinburgh' },
  { src: ALICANTE, city: 'alicante' },
  { src: VIENNA, city: 'vienna' },
  { src: BERLIN, city: 'berlin' },
  { src: PARIS, city: 'paris' },
  { src: NEW_YORK_2, city: 'newYork13' },
  { src: TEXAS, city: 'fortWorth' },
  { src: MANCHESTER, city: 'manchester' },
  { src: MOTHER, city: 'none' },
  { src: LEIPZIG, city: 'leipzig' },
  { src: EDINBURGH_2, city: 'edinburgh' },
  { src: LONDON, city: 'london' },
  { src: TENERIFE, city: 'sanAndres' },
  { src: BONN_UkRAINIAN, city: 'bonn' },
  { src: IZUMO, city: 'izumo14' },
  { src: DALLAS, city: 'dallas' },
  { src: MALAGA, city: 'malaga' },
  { src: LOS_ANGELES, city: 'losAngeles' },
  { src: BIRMINGHAM, city: 'birmingham' },
  { src: OTTAWA, city: 'ottawa12' },
  { src: DENVER, city: 'denver' },
  { src: MILAN, city: 'milan' },
  { src: NEW_YORK, city: 'newYork13' },
  { src: CHICAGO, city: 'chicago' },
  { src: BARCELONA, city: 'barcelona' },
  { src: PARIS_1, city: 'paris' },
  { src: BONN, city: 'bonn' },
  { src: BREMEN, city: 'bremen' },
  { src: DEN_HAAG, city: 'theHague' },
]

export const CITIES: Record<string, { img?: string; country: string; name: string; link: string }> =
  {
    alicante: {
      img: 'ALICANTE',
      country: 'spain',
      name: 'Alicante',
      link: 'https://www.facebook.com/events/1445194540289283/',
    },
    barcelona: {
      img: 'BARCELONA',
      country: 'spain',
      name: 'Barcelona',
      link: 'https://www.instagram.com/reel/DR6_30DjHIF/?igsh=ZDh5cnY4ZTdkNjVm',
    },
    berkeley: {
      country: 'usa',
      name: 'Berkeley',
      link: '',
    },
    berlin: {
      img: 'BERLIN',
      country: 'germany',
      name: 'Berlin',
      link: 'https://www.instagram.com/p/DSAxceHiIKU/',
    },
    bettendorf: {
      country: 'usa',
      name: 'Bettendorf, Iowa',
      link: 'https://www.facebook.com/groups/1607064723004168/posts/2614847065559257/',
    },
    birmingham: { img: 'BIRMINGHAM', country: 'unitedKingdom', name: 'Birmingham', link: '' },
    bonn: {
      img: 'BONN',
      country: 'germany',
      name: 'Bonn',
      link: 'https://www.facebook.com/groups/osteuropaforumbonn/posts/1407165524309389/',
    },
    bremen: { img: 'BREMEN', country: 'germany', name: 'Bremen', link: '' },
    budapest: { country: 'hungary', name: 'Budapest', link: '' },
    chicago: { country: 'usa', name: 'Chicago', link: 'https://www.instagram.com/p/DSGrLP1EfM6/' },
    copenhagen: {
      country: 'denmark',
      name: 'Copenhagen',
      link: 'https://facebook.com/events/s/stop-human-safari-save-kherson/1220516253279753/',
    },
    dallas: {
      img: 'DALLAS',
      country: 'usa',
      name: 'Dallas',
      link: 'https://www.facebook.com/events/1641318096831798/',
    },
    denver: {
      img: 'DENVER',
      country: 'usa',
      name: 'Denver',
      link: 'https://www.facebook.com/events/3741812956114656/',
    },
    edinburgh: {
      img: 'EDINBURGH',
      country: 'unitedKingdom',
      name: 'Edinburgh',
      link: 'https://www.facebook.com/photo?fbid=122236786634168922&set=a.122110901120168922',
    },
    fortWorth: {
      img: 'TEXAS',
      country: 'usa',
      name: 'Fort Worth',
      link: 'https://www.facebook.com/events/1869858713900974/',
    },
    hamburg: {
      country: 'germany',
      name: 'Hamburg',
      link: 'https://x.com/Vilni_De_Ua/status/2001313438358810792',
    },
    houghton: {
      country: 'usa',
      name: 'Houghton, Michigan',
      link: 'https://www.facebook.com/events/1507904243656188/',
    },
    helsinki: {
      country: 'finland',
      name: 'Helsinki',
      link: 'https://ukrainians.fi/fi/stop-human-safari-16-12-klo-17-narinkkatori-hki/',
    },
    izumo14: { country: 'japan', name: 'Izumo', link: '' },
    izumo20: { country: 'japan', name: 'Izumo', link: '' },
    kamloops: { country: 'canada', name: 'Kamloops', link: '' },
    kyiv: { country: 'ukraine', name: 'Kyiv', link: '' },
    leipzig: {
      country: 'germany',
      name: 'Leipzig',
      link: 'https://www.instagram.com/p/DSHsHavjG7u/',
    },
    london: {
      img: 'LONDON',
      country: 'unitedKingdom',
      name: 'London',
      link: 'https://www.eventbrite.com/e/screening-of-a-documentary-film-kherson-human-safari-tickets-1977283934475',
    },
    losAngeles: {
      img: 'LOS_ANGELES',
      country: 'usa',
      name: 'Los Angeles',
      link: 'https://facebook.com/events/s/stop-human-safari-save-kherson/25245573365101413',
    },
    malaga: { img: 'MALAGA', country: 'spain', name: 'Málaga', link: '' },
    manchester: {
      img: 'MANCHESTER',
      country: 'unitedKingdom',
      name: 'Manchester',
      link: 'https://www.instagram.com/p/DSF6kebjJhZ/',
    },
    milan: {
      img: 'MILAN',
      country: 'italy',
      name: 'Milan',
      link: 'https://x.com/liberioltre/status/1998660593386246617',
    },
    munich: {
      img: 'MUNICH',
      country: 'germany',
      name: 'Munich',
      link: 'https://www.facebook.com/events/2599048053801906/',
    },
    newYork13: {
      img: 'NEW_YORK',
      country: 'usa',
      name: 'New York',
      link: 'https://www.instagram.com/p/DSJNpfWEfU7/',
    },
    newYork14: { img: 'NEW_YORK', country: 'usa', name: 'New York', link: '' },
    nienburg: { country: 'germany', name: 'Nienburg (Weser)', link: '' },
    oslo: { country: 'norway', name: 'Oslo', link: '' },
    ostersund: {
      country: 'sweden',
      name: 'Östersund',
      link: 'https://www.facebook.com/events/1902872407329570/',
    },
    ottawa12: {
      img: 'OTTAWA',
      country: 'canada',
      name: 'Ottawa',
      link: 'https://www.facebook.com/RussianEmbassyProtesters/posts/pfbid02r26HLr1xa6gaKqhQnNPEBpaN2agXMck7FP4MgsL1Pa1ytRAxcUqGrFtWnNp59pLHl',
    },
    ottawa13: {
      img: 'OTTAWA',
      country: 'canada',
      name: 'Ottawa',
      link: 'https://www.facebook.com/RussianEmbassyProtesters/photos/eventstop-human-safari-save-kherson-global-rally-fri-dec-12-1230pm-russian-embas/856291767332584/',
    },
    paris: {
      img: PARIS,
      country: 'france',
      name: 'Paris',
      link: 'https://www.facebook.com/groups/pour.lukraine/posts/4385483298395331/',
    },
    plovdiv: { country: 'bulgaria', name: 'Plovdiv', link: '' },
    prague: {
      country: 'czechia',
      name: 'Prague',
      link: 'https://www.facebook.com/events/868528178989820?active_tab=about',
    },
    rosendal: { country: 'southAfrica', name: 'Rosendal', link: '' },
    sanAndres: { country: 'spain', name: 'San Andrés, Tenerife', link: '' },
    sanDiego: {
      country: 'usa',
      name: 'San Diego',
      link: 'https://www.facebook.com/story.php?story_fbid=pfbid0NA7LaipmEpGqz4DDrvdY28z97L6FWXtzxbUFxLvQThge6jsNVgARDVnXb8PeptMWl&id=100078779928673&mibextid=wwXIfr&_rdr',
    },
    sanFrancisco: {
      img: 'SAN_FRANCISCO',
      country: 'usa',
      name: 'San Francisco',
      link: 'https://www.facebook.com/events/s/stop-human-safari-save-kherson/1552004906063989/',
    },
    schwerin: { country: 'germany', name: 'Schwerin', link: '' },
    seattle: {
      img: 'SEATTLE',
      country: 'usa',
      name: 'Seattle',
      link: 'https://facebook.com/events/s/worldwide-rally-stop-the-human/1562930834831737/',
    },
    svetiVlas: { country: 'bulgaria', name: 'Sveti Vlas', link: '' },
    sydney: {
      country: 'australia',
      name: 'Sydney',
      link: 'https://www.facebook.com/groups/Ukrainians.sydney/posts/25211112641845055/',
    },
    tallinn: {
      country: 'estonia',
      name: 'Tallinn',
      link: 'https://www.facebook.com/groups/659010032770800/posts/1210717964266668/',
    },
    tarragona: {
      country: 'spain',
      name: 'Tarragona',
      link: 'https://www.instagram.com/ucranianos_de_tarragona?igsh=MW9tbjJwcGxhZzIwbQ==',
    },
    tbilisi: { country: 'georgia', name: 'Tbilisi', link: '' },
    theHague: {
      img: 'DEN_HAAG',
      country: 'netherlands',
      name: 'The Hague',
      link: 'https://indigo4ua.com/save-kherson/',
    },
    tranas: {
      country: 'sweden',
      name: 'Tranås',
      link: 'https://www.facebook.com/events/827112923446998/',
    },
    vienna: {
      img: 'VIENNA',
      country: 'austria',
      name: 'Vienna',
      link: 'https://www.instagram.com/p/DR1xkHhjPjY/?img_index=1',
    },
    washingtonDC: {
      country: 'usa',
      name: 'Washington, D.C.',
      link: 'https://www.facebook.com/events/s/standwithukraineeveryday/823001877182013/',
    },
    wroclaw: { country: 'poland', name: 'Wroclaw', link: '' },
    mexicoCity: { country: 'mexico', name: 'Mexico City', link: '' },
  }

export const TBC = ['budapest', 'svetiVlas']
export const eleventh = ['bettendorf']
export const twelfth = ['london', 'ottawa12']
export const thirteenth = [
  'alicante',
  'berkeley',
  'birmingham',
  'dallas',
  'edinburgh',
  'kamloops',
  'leipzig',
  'malaga',
  'manchester',
  'nienburg',
  'ostersund',
  'ottawa13',
  'paris',
  'prague',
  'rosendal',
  'sanAndres',
  'schwerin',
  'seattle',
  'sydney',
  'tallinn',
  'tranas',
]

export const fourteenth = [
  'barcelona',
  'berlin',
  'bonn',
  'bremen',
  'chicago',
  'copenhagen',
  'denver',
  'fortWorth',
  'houghton',
  'izumo14',
  'kyiv',
  'losAngeles',
  'mexicoCity',
  'milan',
  'munich',
  // actually also on the 14th, not a mistake
  'newYork14',
  'newYork13',
  'oslo',
  'plovdiv',
  'sanDiego',
  'sanFrancisco',
  'tarragona',
  'tbilisi',
  'theHague',
  'vienna',
  'washingtonDC',
  'wroclaw',
]
export const sixteenth = ['helsinki']

export const twentieth = ['hamburg', 'izumo20']
